import { gsap, SplitText } from "@gsap";
(function () {

	var MENU_SELECTOR = '.pk-menu-item > a, .footer-menu .menu-item > a, .footer-bottom-menu .menu-item > a';
	var SELECTOR = '.pk-button, .contact-item, .sidebar-block-vacancy .contact-row, ' + MENU_SELECTOR;

	/* Zelfde breakpoint als de header: menu-items animeren alleen vanaf desktop. */
	var DESKTOP = window.matchMedia('(min-width: 992px)');

	var TIMING = {
		in:  { duration: 0.45, ease: 'power3.inOut', stagger: 0.05 },
		out: { duration: 0.4,  ease: 'power2.out',   stagger: 0.15 }
	};

	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

	/* Alleen .pk-button-text wordt omgebouwd, zodat een icoon blijft staan. */
	function build(button) {
		var label = button.querySelector('.pk-button-text');

		/* Menulinks hebben geen label-element, dus de tekst wordt in een span gezet. */
		if (!label && button.matches(MENU_SELECTOR) && button.textContent.trim()) {
			label = document.createElement('span');
			label.className = 'pk-button-text';
			label.textContent = button.textContent;
			button.textContent = '';
			button.appendChild(label);
		}

		if (!label || label.hasAttribute('data-text-wrapper')) return null;

		var text = label.textContent.trim();
		if (!text) return null;

		var original = document.createElement('span');
		original.setAttribute('data-text-original', '');
		original.textContent = text;

		var double = original.cloneNode(true);
		double.removeAttribute('data-text-original');
		double.setAttribute('data-text-double', '');

		double.setAttribute('aria-hidden', 'true');

		label.setAttribute('data-text-wrapper', '');
		label.textContent = '';
		label.appendChild(original);
		label.appendChild(double);

		return { original: original, double: double };
	}

	function init(button) {
		var original = null;
		var double = null;
		var tween = null;
		var initialized = false;
		var desktopOnly = button.matches(MENU_SELECTOR);
		var unit = desktopOnly ? 'chars' : 'words';

		function ensureInitialized() {
			if (initialized) return true;

			var parts = build(button);
			if (!parts) return false;

			original = new SplitText(parts.original, { type: unit, mask: unit });
			double = new SplitText(parts.double, { type: unit, mask: unit });

			gsap.set(original[unit], { yPercent: 0 });
			gsap.set(double[unit], { yPercent: 100 });
			initialized = true;

			return true;
		}

		function play(originalY, doubleY, timing) {
			if (desktopOnly && !DESKTOP.matches) return;
			if (!ensureInitialized()) return;
			if (tween) tween.kill();

			tween = gsap.timeline()
				.to(original[unit], {
					yPercent: originalY,
					duration: timing.duration,
					ease: timing.ease,
					stagger: { amount: timing.stagger }
				})
				.to(double[unit], {
					yPercent: doubleY,
					duration: timing.duration,
					ease: timing.ease,
					stagger: { amount: TIMING.out.stagger }
				}, '<');
		}

		var enter = function () { play(-100, 0, TIMING.in); };
		var leave = function () { play(0, 100, TIMING.out); };

		button.addEventListener('mouseenter', enter);
		button.addEventListener('mouseleave', leave);

		button.addEventListener('focus', enter);
		button.addEventListener('blur', leave);
	}

	function setup(scope) {
		if (typeof gsap === 'undefined' || typeof SplitText === 'undefined') return;

		gsap.registerPlugin(SplitText);

		(scope || document).querySelectorAll(SELECTOR).forEach(function (button) {
			if (button.dataset.animate === 'none' || button.hasAttribute('data-text-init')) return;
			button.setAttribute('data-text-init', '');
			init(button);
		});
	}

	setup();

	/* AJAX-geladen kaarten (filter, load more) roepen deze aan met hun container. */
	window.pkButtonTextAnimation = setup;
})();